<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createContactData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tr v-for="(item,index) in dataTable" :key="index">
            <td width="5%" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td width="10%">{{item.branch ? item.branch.branch_name_en : ''}}</td>
            <td>{{item.mini_tcdc ? item.mini_tcdc.branch_name_en : ''}}</td>
            <td>{{item.description_en}}</td>
            <td width="15%" >{{item.contact_email}}</td>
            <td width="12%">{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td width="5%" >
              <a @click="showContactData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          <tbody>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../../components/Input/InputSearch";
    import CircleButton from "../../../components/Button/CircleButton";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    export default {
        name: "ContactTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch},
      data() {
        return {
          title: "Contact",
          headers: [
            { id: 1, text: "No." },
            { id: 2, text: "Branch" },
            { id: 3, text: "Mini TCDC" },
            { id: 4, text: "Description" },
            { id: 5, text: "E-mail" },
            { id: 6, text: "Update date" },
            { id: 7, text: "Edit" }
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          }
        };
      },
      created() {
          this.getContactTable(1);
      },
      methods:{
        getContactTable(page){
          this.$store.dispatch("Contact/getContact",page).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
          }).catch(()=>{
            alert("cannot get contact data");
          })
        },
        changePage(val){
          this.dataPaginate.current_page = val;
          this.$store.dispatch("Contact/getContact", this.dataPaginate.current_page).then(res => {
            if (res.response_code == 200) {
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            } else {
              alert(res.response_msg);
            }
          });
        },
        goToContactEdit(){
          this.$router.push("/contact/edit");
        },
        showContactData(id){
          this.$store.dispatch("Contact/showContact",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("Contact/setFormContact",res.result).then(()=>{
                this.goToContactEdit();
              })
            }
          }).catch(()=>{
            alert("cannot get contact data");
          });
        },
        createContactData(){
          this.$store.dispatch("Contact/clearFormData").then(()=>{
            this.goToContactEdit();
          });
        },

      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
